export default __webpack_public_path__ + "static/media/closed-coffin.2926c279.png";